import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import i18n from "i18next";
import { RootState } from "../store";

type LangaugeState = {
  currentLanguage: "ar" | "en"
}

export const languageSlice = createSlice({
  name: "language",
  initialState: {
    currentLanguage: "ar"
  } as LangaugeState,
  reducers: {
    setLanguage: (state, action: PayloadAction<"en"|"ar">) => {
      state.currentLanguage = action.payload;
    },
  },
});

export const languageSetterMiddleWare = (store: any) => (next: any) => (action: any) => {
  if (action.type === "language/setLanguage") {
    i18n.changeLanguage(action.payload);
  }
  return next(action);
};

export const selectLanguage = (state: RootState) => state.language;

export const { setLanguage } = languageSlice.actions;
